import { render, staticRenderFns } from "./in.vue?vue&type=template&id=6f67a321&scoped=true&"
import script from "./in.vue?vue&type=script&lang=js&"
export * from "./in.vue?vue&type=script&lang=js&"
import style0 from "./in.vue?vue&type=style&index=0&id=6f67a321&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67a321",
  null
  
)

export default component.exports